import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import {LineWave} from "react-loader-spinner";
import "react-toastify/dist/ReactToastify.css";

import bannerimg from "../../assets/userlogin.webp";

import { useNavigate } from "react-router-dom";

import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import axios from "axios";

import styles from "../../components/tradeall.module.css"


const UserSignin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [Loading, setLoading] = useState(false);
  


  
  const verifytokenexists = async () => {
    try {
      const tokenfromls = localStorage.getItem("usertoken");
    
      const id = localStorage.getItem("userregisterId");
      const h = { authorization: tokenfromls };
   
      if (tokenfromls) {
        const res = await axios.get(`
          ${process.env.REACT_APP_URL}/protect/userprotectedroute`,
          { headers: h }
        );
    
       
        if (res) {
        
          if (res.data.m === id) {
            navigate("/user/economicdata");
          }
        }
      } 
    } catch (e) {
      // console.log(e)
      if((e.response && e.response.status)  === 401 || (e.response && e.response.status === 400)){
        console.log("Token malfunction");
      }
    
    }
  };
  
  useEffect(() => {
    verifytokenexists()
  }, []);
  
  const validateEmail = (email) => {
    const emailRegex = /.+@.+/;
    return emailRegex.test(email);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    setIsLoggingIn(true);
    if (!email || !password) {
      toast.error("Please fill the required fields", {
        position: "top-right"});
        setIsLoggingIn(false);
        setLoading(false)
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Invalid email address , @ is mandatory", {
        position: "top-right"});
        setIsLoggingIn(false);
        setLoading(false)
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/usersignin`,
        { email, password },
        {headers: {"Content-Type": "application/json"},
        }
      );
      setLoading(false)
      setIsLoggingIn(true);
      
      
      const data = response.data;


      const { approvalStatus } = data.user; 

      localStorage.setItem("username" , response.data.user.name )
      const userregisterId = response.data.user._id          ;
      localStorage.setItem("userregisterId" , userregisterId )
      localStorage.setItem("usertoken", data.usertoken);
      setEmail("");
      setPassword("");

      navigate("/user/economicdata");
    } 
   
    catch (error) {
      setLoading(false);
      setIsLoggingIn(false);

      if (error.response && error.response.data) {
        const errorMessage = error.response.data.message;
    
        if (errorMessage === "Wait for the admin approval") {
          toast.error(
            "Your profile is in review. You will get a confirmation email once approved.",
            { position: "top-right" }
          );
        } else if (errorMessage === "Your registration was rejected") {
          toast.error(
            "Your account has been rejected. Please contact support.",
            { position: "top-right" }
          );
        } else if (errorMessage === "Error in login") {
          toast.error(
            "Error during login! Please check credentials.",
            { position: "top-right" }
          );
        } else {
          toast.error(
            "Error during login! Please check credientials again",
            { position: "top-right" }
          );
        }
      } else if (error.request) {
       
        console.error("No response received:", error.request);
        toast.error("Network error. Please check your connection.", {
          position: "top-right",
        });
      } else {
        
        console.error("Error message:", error.message);
        toast.error("An unexpected error occurred. Please try again.", {
          position: "top-right",
        });
      }
    }
    
  };

  return (
    <>
      <section className={`${styles.usersignin_bg}  `}>
       
       <div className=" justify-center items-center py-[0.5rem] sm:py-[0.5rem] md:py-[4.5rem] lg:py-[5.5rem] xl:py-[6.5rem]  px-[5%] sm:px-[5%] md:px-[4rem] lg:px-[5rem] xl:px-[7rem] h-full flex w-[100%] flex-col sm:flex-col md:flex-col lg:flex-row xl:flex-row">
       <div className="w-[100%] sm:w-[100%] md:w-[100%]  lg:w-[50%] xl:w-[50%] flex justify-center items-center ">
          <img
            src={bannerimg}
            alt="bannerimg"
            className="h-[30vh] sm:h-[30vh] md:h-[35vh] lg:h-[55vh] xl:sm:h-[55vh]"
          ></img>
        </div>
        <div className=" w-[100%] z-[999] sm:w-[100%] md:w-[100%]  lg:w-[50%] xl:w-[50%] flex flex-col items-center justify-center  py-8 lg:py-0 " >
          

       <div className="rounded-[34px] w-full flex items-center justify-center px-[5%] sm:px-[5%] md:px-[4.5rem] lg:px-[4.5rem] xl:px-[4.5rem]  py-[5%] sm:py-[5%] md:py-[1.5rem] lg:py-[4.5rem] xl:py-[7.5rem]  bg-white" style={{ boxShadow: '0px 2px 14.1px 0px rgba(223, 223, 223, 0.50)' }}>
       <div className="w-full bg-white     md:mt-0 sm:max-w-md xl:p-0 rounded-[34px]"  >
            <div className=" space-y-4 md:space-y-4  ">
              <h1 className="text-[24px] sm:text-[24px] md:text-[32px] lg:text-[32px] xl:text-[32px] font-bold text-center text-[#240D3A]">Sign In</h1>

              <p className="text-[#240d3a] text-center font-semibold text-[14px] sm:text-[14px] md:sm:text-[14px] lg:sm:text-[16px] xl:sm:text-[16px]  ">To access your account, please provide the <br/>following information.</p>
              <form onSubmit={handleSubmit} className="my-10">
                <div className="flex flex-col  ">
                  <label htmlFor="email" >
                    <p className="font-bold text-[#240d3a] pb-2 mt-0 sm:mt-0 md:mt-4 text-[14px] sm:text-[14px] md:sm:text-[14px] lg:sm:text-[16px] xl:sm:text-[16px] ">
                      Email address
                    </p>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="off"
                      className="w-full py-3 text-[14px] placeholder-[#545454] font-semibold  input-field border border-[#8692A6] rounded-lg px-5 focus:outline-none focus:border-slate-500 hover:shadow"
                      placeholder="Enter email"
                    />
                  </label>
                  <label htmlFor="password" className="relative mt-4">
                    <p className="font-bold text-[#240d3a] pb-2 text-[14px] sm:text-[14px] md:sm:text-[14px] lg:sm:text-[16px] xl:sm:text-[16px] ">Password</p>
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="off"
                      className="w-full py-3 text-[14px] placeholder-[#545454] font-semibold input-field border border-[#8692A6] rounded-lg px-5 focus:outline-none focus:border-slate-500 hover:shadow pr-10"
                      placeholder="Enter password"
                    />
                    {showPassword ? (
                      <IoIosEye
                        className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      // <img src={eye_img_open}  onClick={() => setShowPassword(!showPassword)} className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500 w-[16px]"></img>
                      <IoIosEyeOff
                        className="absolute top-[70%] transform -translate-y-1/2 right-3 cursor-pointer text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                     
                    )}
                  </label>

               
                      <a  href="/user/forgetpassword" className={`${styles.forgetpassword} cursor-pointer  text-end text-[13px]  space-y-0   font-bold   text-[#545454]`}>
                      <NavLink to="/user/forgetpassword" className="mt-3">Forgot Password?</NavLink></a>
                   
                  <button
                    type="submit"
                    className=" w-full py-3 font-bold text-white bg-[#240D3A] hover:bg-[#5a2989] rounded-lg border-indigo-500 hover:shadow inline-flex space-x-2 items-center justify-center mt-5 sm:mt-5 md:mt-10"
                  >
                    <span>{isLoggingIn ? "Signing you in..." : "Sign In"}</span>
                    {/* <PiArrowSquareRight className="text-xl" /> */}
                  </button>
                  <div className="justify-center items-center flex mt-4"><p className="text-sm font-semibold text-[#240d3a]">
                    Don't have an account?
                    <a
                      href="/user/signup"
                      className="font-bold text-[#240D3A] ml-2 hover:text-[#5a2989]"
                    >
                      <NavLink to="/user/signup"> Register Here </NavLink>
                    </a>
                  </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
       </div>
      





          {
             Loading ?  <div className="fixed bottom-0 right-0 mb-2 flex items-end justify-end   w-full">
             <LineWave 
               height="60"
               width="60"
               color="#111827"
               ariaLabel="bars-loading"
               wrapperStyle={{}}
               wrapperClass=""
               visible={true}
               className=" w-10 h-10 flex items-center justify-center  mt-10 "
             />
           </div> :
            <div>
            
           </div>
          }
      
        </div>

       </div>

      </section>
      
    </>
  );
};

export default UserSignin;
